import { render, staticRenderFns } from "./InquiryReplyList.vue?vue&type=template&id=18fb7bdb&"
import script from "./InquiryReplyList.vue?vue&type=script&lang=ts&"
export * from "./InquiryReplyList.vue?vue&type=script&lang=ts&"
import style0 from "./InquiryReplyList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports